// src/pages/AboutPage.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import PageMeta from '../components/SEO/PageMeta';
import StructuredData from '../components/SEO/StructuredData';
import CtaBanner from '../components/CtaBanner';
import Clients from '../components/Clients';
import aboutImg from '../images/industrial-ai.jpg';

const AboutPage = () => {
    const { t } = useTranslation();
    const story = t('about_page.story', { returnObjects: true }) || [];
    const expertise = t('about_page.expertise', { returnObjects: true }) || [];

    return (
        <>
            <PageMeta
                title={t('about_page.meta_title')}
                description={t('about_page.meta_description')}
                path="/about"
            />
            <StructuredData type="page" page={{ name: t('nav.about'), path: '/about', kind: 'AboutPage', description: t('about_page.meta_description') }} />

            {/* Page header */}
            <div className="bg-slate-900 py-16">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-aos="fade-up">
                    <h1 className="text-4xl font-bold text-white mb-4">{t('about_page.title')}</h1>
                    <p className="text-lg text-gray-300 max-w-3xl mx-auto">{t('about_page.subtitle')}</p>
                </div>
            </div>

            {/* Story */}
            <div className="bg-white py-12">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex flex-col-reverse lg:flex-row gap-10 items-center">
                        <div className="lg:w-1/2" data-aos="fade-right">
                            <img alt={t('about_page.title')} className="rounded-xl w-full h-auto" src={aboutImg}
                                 width="1152" height="768" loading="lazy" decoding="async" />
                        </div>
                        <div className="lg:w-1/2" data-aos="fade-left">
                            {Array.isArray(story) && story.map((p, i) => (
                                <p key={i} className="text-gray-700 text-lg mb-4 text-justify">{p}</p>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            {/* Expertise */}
            <div className="bg-gray-100 py-12">
                <div className="max-w-6xl mx-auto px-4 sm:px-8">
                    <h2 className="text-3xl font-bold text-primary text-center mb-2">{t('about_page.expertise_title')}</h2>
                    <div className='flex justify-center mb-8'>
                        <div className='w-24 border-b-4 border-primary'></div>
                    </div>
                    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
                        {Array.isArray(expertise) && expertise.map((item, i) => (
                            <div key={i} className="bg-white rounded-lg shadow p-5" data-aos="fade-up" data-aos-delay={(i % 3) * 100}>
                                <h3 className="font-bold text-gray-800 mb-1">{item.title}</h3>
                                <p className="text-sm text-gray-600 text-justify">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Clients />

            <CtaBanner
                title={t('about_page.cta_title')}
                text={t('about_page.cta_text')}
                buttonLabel={t('common.discuss_project')}
            />
        </>
    );
};

export default AboutPage;
